module.exports = __webpack_public_path__ + "img/chrbutton_en.3b1e911b.png";